import { render, staticRenderFns } from "./CopperRecord.vue?vue&type=template&id=7ebc8cb4&scoped=true&"
import script from "./CopperRecord.vue?vue&type=script&lang=js&"
export * from "./CopperRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ebc8cb4",
  null
  
)

export default component.exports